<template>
  <p class="tagline">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448.13 108.14">
      <path
        class="cls-3"
        fill="#efb568"
        stroke-width="0"
        d="m15.05,108.14c29.81-15.66,60.36-25.73,90.07-30.21h0c3.57-.74,6.35-1.44,8.58-2.13-2.13-6.89-4.27-13.75-6.42-20.58-2.65-8.43-5.3-16.83-7.96-25.17C66.41,35.68,32.6,48.14,0,67.41c18.29-2.55,36.81-2.98,55.21-1.29-13.44,12.89-26.83,26.9-40.16,42.03"
      />
      <path
        class="cls-2"
        fill="#eba547"
        stroke-width="0"
        d="m93.34,71.51c7.99,1.24,20.24,3.49,11.79,6.42,3.57-.74,6.35-1.44,8.58-2.13,5.24-1.61,7.39-3.14,9.47-4.93,7.54-6.49-.44-16.93-7.28-18.54l-8.6,2.89-15.96,5.37c-16.22,2.91-7.59,9.45,2.01,10.93"
      />
      <path
        class="cls-3"
        fill="#efb568"
        stroke-width="0"
        d="m433.08,108.14c-29.81-15.66-60.36-25.73-90.07-30.21h0c-3.57-.74-6.35-1.44-8.58-2.13,2.13-6.89,4.27-13.75,6.42-20.58,2.65-8.43,5.3-16.83,7.96-25.17,32.91,5.65,66.72,18.1,99.32,37.37-18.29-2.55-36.81-2.98-55.2-1.29,13.44,12.89,26.83,26.9,40.16,42.03"
      />
      <path
        class="cls-2"
        fill="#eba547"
        stroke-width="0"
        d="m354.79,71.51c-7.99,1.24-20.24,3.49-11.79,6.42-3.57-.74-6.35-1.44-8.58-2.13-5.24-1.61-7.39-3.14-9.47-4.93-7.54-6.49.44-16.93,7.28-18.54l8.6,2.89,15.95,5.37c16.23,2.91,7.6,9.45-2,10.93"
      />
      <path
        class="cls-1"
        fill="#f4c077"
        stroke-width="0"
        d="m369.4,21.82c-4.21,12.87-8.43,25.78-12.66,38.73-87.45-18.87-177.91-18.87-265.36,0-4.22-12.96-8.44-25.87-12.66-38.73-.74-2.25.49-4.68,2.74-5.42.12-.04.24-.07.36-.1,93.58-21.74,190.9-21.74,284.48,0,2.31.54,3.74,2.85,3.2,5.16-.03.12-.06.24-.1.36"
      />
    </svg>
    <svg width="260" height="130" class="tagline__text">
      <path id="curve" d="M 0 120 C 0 120, 130 90, 260 120" fill="transparent" />
      <text>
        <textPath xlink:href="#curve">
          {{ text }}
        </textPath>
      </text>
    </svg>
  </p>
</template>

<script>
export default {
  name: 'Tagline',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
}
</script>
